export enum AmazonStoreType {
    // NA region
    AmazonUS=0,
    AmazonCA=1,
    AmazonMX=2,
    AmazonBR=10,

    // EU region
    AmazonUK=3,
    AmazonDE=4,
    AmazonES=5,
    AmazonFR=6,
    AmazonIT=7,
    AmazonPL=8,
    AmazonAE=9,
    AmazonEG=11,
    AmazonIN=12,
    AmazonNL=13,
    AmazonSA=14,
    AmazonTR=15,
    AmazonSE=16,
    AmazonBE=17,

    //Far East Region
    AmazonSG,
    AmazonAU,
    AmazonJP,
}

export enum AmazonSalesRegion {
    NorthAmericaRegion,
    EuropeRegion,
    FarEastRegion
}